<template>
    <form @submit.prevent class="form-search" :disabled="disabled">
        <label class="form-search__inner" :class="{ 'borderless': borderless }">
          <input
            class="form-search__input"
            type="text"
            :value="value"
            :placeholder="placeholder"
            :disabled="disabled"
            ref="input"
            @input="onSubmit"
          />
          <button v-if="!value" class="form-search__submit" :disabled="disabled">
              <svg class="search-icon" viewBox="0 0 23 23" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="10.0328" cy="10.0294" r="8.2945" stroke-width="1.5" />
                  <path d="M15.8472 15.8438L21.6615 21.6581" stroke-width="1.5" />
              </svg>
          </button>

          <button v-else class="form-search__submit" :disabled="disabled" type="button" @click="clearValue">
            x
          </button>
          <button v-if="!dynamic" v-show="false" @click="onSubmit" />
        </label>
    </form>
</template>

<script>

export default {
  name: 'search-form',
  props: {
    value: String,
    placeholder: {
      type: String,
      default: 'Поиск'
    },
    borderless: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    dynamic: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    onSubmit () {
      this.$emit('form-submit', this.$refs.input.value)
    },
    clearValue () {
      this.$refs.input.value = ''
      this.onSubmit()
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.form-search {
  width: 100%;
  height: 40px;

  &__inner {
    position: relative;
    display: flex;
    width: 100%;
    background: $color_main;
    transition: .3s;

    &.borderless {
      border: none !important;
    }
  }

  &__input {
    flex: 1;
    border-radius: 3px;
    border: 1px solid $color__forest-wolf;
    padding: 10px 40px 10px 15px;
    width: 100%;
    height: 100%;
    color: $font_color_second;
    background: transparent;
    transition: .3s;

    &:focus {
      border: 1px solid $color__orange;
      box-shadow: 0 0 0 1px $color__orange;
    }

    &:hover {
      border: 1px solid $color__copper-pink;
    }
  }

  &__submit {
    position: absolute;
    top: auto;
    right: 0;
    height: 100%;
    cursor: pointer;
    background: transparent;
    color: $color__copper-pink;
    padding-right: 15px;
  }

  &[disabled] {
    pointer-events: none;

    .form-search {
      &__inner {
        border: 1px solid $color_deactive !important;
      }

      &__submit {
        color: $color_deactive !important;
      }
    }
  }
}
</style>
